import { Box, styled } from '@mui/material';

export const AuthBoxContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100vh',
  width: '100vw',
  backgroundColor: theme.palette.background.backdrop,
}));

export const AuthBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '16px',
  backgroundColor: theme.palette.background.paper,
  borderRadius: '12px',
  width: '420px',
  height: 'fit-content',
  padding: '24px',
  border: '1px solid transparent',
}));
